import { HomePageMobileTimeSheet } from "./mobile/home/Index";
import TimeSheet from "./web/list";

export function TimeSheetComponent() {
  return <TimeSheet />;
}

export function TimeSheetMobile() {
  return <HomePageMobileTimeSheet />;
}
